import { Formatter } from "@wingspanhq/fe-component-library";

export const formatter = new Formatter({
  noDataIndicator: "–",
  trueIndicator: "Yes",
  falseIndicator: "No"
});
